import { CartComponent } from './cart.component';

export const Cart = CartComponent;
